export default function SettingListIcon(
  props: Pick<
    React.SVGProps<SVGSVGElement>,
    "className" | "fill" | "fillOpacity"
  >,
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
    >
      <path
        d="M2.08203 11.9998H6.7487V13.3332H2.08203V11.9998ZM2.08203 7.33317H8.08203V8.6665H2.08203V7.33317ZM2.08203 2.6665H15.4154V3.99984H2.08203V2.6665ZM14.5314 8.68317L15.302 8.4225L15.9687 9.57717L15.358 10.1138C15.4349 10.4783 15.4349 10.8547 15.358 11.2192L15.9687 11.7558L15.302 12.9105L14.5314 12.6498C14.258 12.8965 13.9327 13.0865 13.5747 13.2032L13.4154 13.9998H12.082L11.922 13.2025C11.5682 13.0869 11.2425 12.8984 10.966 12.6492L10.1954 12.9105L9.5287 11.7558L10.1394 11.2192C10.0625 10.8547 10.0625 10.4783 10.1394 10.1138L9.5287 9.57717L10.1954 8.4225L10.966 8.68317C11.2394 8.4365 11.5647 8.2465 11.9227 8.12984L12.082 7.33317H13.4154L13.5754 8.1305C13.9327 8.2465 14.258 8.43717 14.5314 8.68384V8.68317ZM12.7487 11.9998C13.1023 11.9998 13.4415 11.8594 13.6915 11.6093C13.9416 11.3593 14.082 11.0201 14.082 10.6665C14.082 10.3129 13.9416 9.97374 13.6915 9.72369C13.4415 9.47365 13.1023 9.33317 12.7487 9.33317C12.3951 9.33317 12.0559 9.47365 11.8059 9.72369C11.5558 9.97374 11.4154 10.3129 11.4154 10.6665C11.4154 11.0201 11.5558 11.3593 11.8059 11.6093C12.0559 11.8594 12.3951 11.9998 12.7487 11.9998Z"
        fill={props.fill || "#0F1324"}
        fillOpacity={props.fillOpacity || "0.6"}
      />
    </svg>
  );
}
